export const Thanks = () => {
  return (
    <div className="text-center">
      <h1 className="heading">Obrigado pela avaliação!</h1>
      <p className="body">Volte sempre 👋!</p>
    </div>
  );
};
